module.exports = __webpack_public_path__ + "img/logo.e0baaae1.png";